{
	"title": "Audio recap",
	"list": {
		"title": "All audio",
		"subtitle": "Create a personalized podcast, audiobook and more",
		"empty": "No audio recaps",
		"create": "Create audio",
		"backToList": "Back to audio recaps",
		"errorTitle": "Failed to load audio",
		"errorDescription": "Check your connection and try again.",
		"retry": "Retry",
		"emptyTitle": "No audio recaps yet",
		"emptyDescription": "AI will produce 4 audio formats of your material: podcast, lecture, audiobook, or short summary.",
		"emptyFilterTitle": "No audio in this format",
		"emptyFilterDescription": "Create audio or pick another format filter.",
		"filterAria": "Filter by format",
		"filterAll": "All",
		"searchPlaceholder": "Search audio…"
	},
	"card": {
		"listen": "Listen",
		"resume": "Resume",
		"actions": "Actions",
		"open": "Open",
		"share": "Share",
		"delete": "Delete",
		"regenerate": "Regenerate"
	},
	"formats": {
		"podcast": "Podcast",
		"podcastDescription": "Two voices, dialogue",
		"lecture": "Lecture",
		"lectureDescription": "Single voice, academic tone",
		"audiobook": "Audiobook",
		"audiobookDescription": "Single voice, narrative style",
		"summary": "Quick summary",
		"summaryDescription": "Condensed voice-over"
	},
	"voices": {
		"single": "Single voice",
		"multi": "Multi-voice",
		"selectVoice": "Choose voice",
		"descriptions": {
			"warm": "Warm, friendly",
			"deep": "Deep, academic",
			"energetic": "Energetic, podcast host",
			"calm": "Calm narrator",
			"young": "Young, modern",
			"confident": "Confident lecturer"
		}
	},
	"generation": {
		"inProgress": "Generating audio…",
		"ready": "Audio ready",
		"failed": "Audio generation failed",
		"estimatedTime": "About {minutes} min"
	},
	"detail": {
		"downloadFailed": "Could not download the audio",
		"loadFailed": "Could not load the audio",
		"retry": "Retry",
		"generateFailedTitle": "Could not generate the audio",
		"generateFailedHint": "Regenerate with the same settings or create a new one.",
		"failReason": {
			"SOURCE_TOO_SHORT": {
				"title": "Not enough source material",
				"hint": "There is almost no text in the source — nothing to retell. Add a longer material or pick several."
			}
		},
		"createNew": "Create new",
		"downloadAria": "Download MP3",
		"shareAria": "Share",
		"backMaterial": "Material",
		"backSubsection": "To subsection",
		"backAll": "All audio",
		"gen": {
			"autoRefresh": "The page will refresh automatically — feel free to close and come back later.",
			"queued": {
				"title": "Queued",
				"hint": "Starting soon — waiting for a free generation slot."
			},
			"generating-script": {
				"title": "Writing the script",
				"hint": "AI is reading the material and writing the dialogue. Usually 20–60 seconds."
			},
			"generating-tts": {
				"title": "Synthesizing narration",
				"hint": "Voicing the lines with the chosen voices. Longer audio takes longer."
			}
		},
		"regenerate": "Regenerate",
		"durationShortfall": "Shorter than requested",
		"durationShortfallHint": "You asked for {target} min, the result is {actual}. The source material did not stretch that far — add more materials or pick a shorter length."
	},
	"player": {
		"play": "Play",
		"pause": "Pause",
		"skipBack": "−15 seconds",
		"skipForward": "+15 seconds",
		"speed": "Speed",
		"volume": "Volume",
		"settings": "Playback settings",
		"download": "Download MP3",
		"close": "Close player"
	},
	"miniPlayer": {
		"defaultTitle": "Audio recap",
		"position": "Playback position",
		"close": "Close player",
		"speedAria": "Playback speed {rate}",
		"languageNote": "This recording is in {language}"
	},
	"generateDialog": {
		"title": "Generate audio recap",
		"material": "Material",
		"materialPlaceholder": "Pick a material…",
		"materialSearch": "Find material…",
		"format": "Format",
		"voicesLabel": "Voices",
		"language": "Language",
		"languagePlaceholder": "Language",
		"voice": "Voice",
		"voicePlaceholder": "Voice",
		"voiceSearch": "Find voice…",
		"estTitle": "Generation estimate",
		"estDetail": "~{words} words · ~{minutes} min",
		"quotaExhausted": "Your monthly quota is used up. Upgrade your plan to continue.",
		"cancel": "Cancel",
		"submit": "Create audio",
		"format.podcast.label": "Podcast",
		"format.podcast.description": "Lively two-host dialogue",
		"format.lecture.label": "Lecture",
		"format.lecture.description": "Single voice, academic style",
		"format.audiobook.label": "Audiobook",
		"format.audiobook.description": "Narrative pacing",
		"format.summary.label": "Summary",
		"format.summary.description": "Condensed voice-over of the main points",
		"estMinutes": "~{minutes} min",
		"defaultTitle": "Audio recap",
		"toast": {
			"queued": "Audio queued for generation. We'll notify when it's ready.",
			"failed": "Failed to start generation",
			"deleted": "Audio recap deleted",
			"deleteFailed": "Failed to delete",
			"downloadFailed": "Failed to download audio"
		}
	},
	"wizard": {
		"title": "New audio recap",
		"description": "Pick a material, format, voices and length in 4 steps.",
		"step.source": "Source",
		"step.format": "Format",
		"step.voices": "Voices",
		"step.length": "Length",
		"step1Hint": "Pick a material or upload a new one — AI writes the script from it.",
		"step2Hint": "The format sets the delivery and number of voices. Style is refined below.",
		"step3Hint": "Pick the voices — you can preview them before starting.",
		"step4Hint": "Longer audio takes more time to generate and uses more quota.",
		"back": "Back",
		"cancel": "Cancel",
		"next": "Next",
		"generate": "Generate",
		"submitting": "Starting…",
		"queued": "Request accepted. Generation started.",
		"errorNoMaterial": "Pick a material first.",
		"errorGeneric": "Could not start generation. Please retry.",
		"defaultTitle": "Audio recap",
		"titleLabel": "Title",
		"titlePlaceholder": "e.g. “Podcast on chapter 3”",
		"titleHint": "Used in the player and search.",
		"voiceMode": "Voice mode",
		"voicePrimary": "Voice",
		"voiceHostA": "Host A",
		"voiceHostB": "Host B",
		"personaPreset.label": "Persona style",
		"personaPreset.placeholder": "Pick a style…",
		"personaPreset.hint": "Shapes the manner of the AI hosts in the recap.",
		"toast": {
			"deleted": "Audio recap deleted",
			"deleteFailed": "Failed to delete",
			"downloadFailed": "Failed to download MP3",
			"regenerateStarted": "Regeneration started",
			"regenerateFailed": "Couldn't start regeneration"
		}
	},
	"voicePicker": {
		"placeholder": "Voice",
		"search": "Find voice…",
		"preview": "Preview",
		"female": "Female",
		"male": "Male",
		"neutral": "Neutral",
		"mood.energetic": "Energetic",
		"mood.calm": "Calm",
		"mood.warm": "Warm",
		"mood.authoritative": "Authoritative",
		"mood.friendly": "Friendly",
		"mood.neutral": "Neutral"
	},
	"voiceGrid": {
		"filterAll": "All",
		"filterFemale": "Female",
		"filterMale": "Male",
		"play": "Play",
		"playing": "Playing…",
		"stop": "Stop",
		"empty": "No voices for the selected filter"
	},
	"lengthSlider": {
		"label": "Target length",
		"minutes": "{minutes} min",
		"minutesShort": "{minutes}m"
	},
	"costPreview": {
		"title": "Generation cost",
		"estimatedWords": "Estimated words",
		"estimatedCost": "Cost",
		"quotaMinutes": "Quota usage",
		"targetDuration": "Length",
		"minutes": "{minutes} min",
		"failed": "Could not estimate cost.",
		"quotaExceeded": "Not enough quota — upgrade or shorten the recap."
	},
	"scriptPreview": {
		"title": "Script preview",
		"placeholder": "The full script becomes available after the first generation. AI will use your settings and material now."
	},
	"transcript": {
		"title": "Transcript",
		"lineCount": "{count, plural, one {# line} other {# lines}}",
		"empty": "The script is still being generated.",
		"unavailable": "Script is not available for this audio.",
		"seekToSegment": "Jump to {ts}",
		"askAboutSegment": "Ask about this segment",
		"scrollToActive": "Jump to current line",
		"citationOpen": "Source {n}",
		"citationLabel": "Source {n}",
		"citationLoading": "Preview unavailable for chunk {id}",
		"citationOpenMaterial": "Open in material",
		"citationMaterialFallback": "Material",
		"citationChunkOrder": "Fragment {n}",
		"citationGroupAria": "{count, plural, one {# source: {name}} other {# sources: {name}}}",
		"role": {
			"host": "Host",
			"expert": "Expert",
			"student": "Student",
			"narrator": "Narrator"
		},
		"askSegmentPrompt": "Explain this fragment of the audio recap: \"{text}\""
	},
	"tabs": {
		"transcript": "Transcript",
		"chat": "Chat"
	},
	"chat": {
		"title": "Chat about this recap",
		"ariaLabel": "Audio recap chat",
		"placeholder": "Ask anything about this recap…",
		"send": "Send",
		"clear": "Clear",
		"close": "Close",
		"expand": "Chat",
		"collapse": "Hide chat",
		"thinking": "Thinking…",
		"answerFailed": "Couldn't get an answer",
		"openInVoiceTutor": "Open Voice Tutor",
		"empty": {
			"title": "Ask about this recap",
			"hint": "You can quote any line via the button on the right in the transcript."
		},
		"suggest": {
			"idea": "What's the main idea?",
			"explainSimpler": "Explain the last paragraph more simply",
			"whereToStart": "Where should I start reading the material?"
		},
		"quote": {
			"remove": "Remove quote"
		},
		"softCap": {
			"toast": "Looks like you need a full tutor",
			"hint": "Voice Tutor lets you talk by voice and dive deeper into the material."
		},
		"askTutor": "Ask the tutor"
	},
	"share": {
		"title": "Public link",
		"description": "Anyone with the link can listen without an account.",
		"url": "URL",
		"copy": "Copy",
		"copyError": "Could not copy.",
		"create": "Create link",
		"revoke": "Revoke",
		"revoked": "Access revoked.",
		"error": "Could not update access.",
		"close": "Close",
		"notShared": "Not shared yet.",
		"publicWarning": "The link works until you revoke it.",
		"publicPage": {
			"createOwn": "Make your own",
			"heading": "Audio recap",
			"subheading": "Shared recording",
			"error": "Recording is unavailable or the link was revoked.",
			"footerHint": "Made on StudyHub —",
			"footerCta": "try it free",
			"position": "Playback position",
			"play": "Play",
			"pause": "Pause",
			"loading": "Loading audio…",
			"download": "Download audio"
		}
	},
	"generating": {
		"phases": {
			"script": {
				"title": "Writing the script",
				"description": "AI is analyzing your material and drafting the dialogue"
			},
			"tts": {
				"title": "Synthesizing voices",
				"description": "Voices come alive in a single TTS call"
			},
			"finalize": {
				"title": "Finalizing",
				"description": "Mixing audio and normalizing loudness"
			}
		}
	},
	"citations": {
		"tooltip": {
			"openMaterial": "Open in material",
			"chunkPreviewLabel": "Material excerpt"
		},
		"footnoteAriaLabel": "Source {n}"
	},
	"step1": {
		"tabs": {
			"aria": "Source",
			"existing": "From materials",
			"upload": "Upload",
			"link": "Link",
			"text": "Text"
		},
		"selectMaterials": "Select materials",
		"materialsSelected": "{count, plural, one {# material selected} other {# materials selected}}",
		"collectionSelected": "Folder: {name}",
		"changeSelection": "Change",
		"materialAdded": "Material added"
	},
	"audioRecap": {
		"presetPicker": {
			"label": "Style direction",
			"hint": "Pick a delivery style — it sets the tone of your audio.",
			"exampleAria": "Example for the {name} preset",
			"exampleClose": "Close"
		},
		"presets": {
			"podcast-friend": {
				"label": "Explain like a friend",
				"description": "Hosts speak in plain language, use everyday analogies and unpack any jargon as it appears.",
				"example": "Hey! Today we're unpacking…"
			},
			"podcast-deep": {
				"label": "Deep dive",
				"description": "Hosts unpack nuances, edge cases and exceptions, debate one another and reference the source often.",
				"example": "Now here's the catch…"
			},
			"podcast-debate": {
				"label": "Expert debate",
				"description": "Pro/contra format: one host defends a position while the other pushes back. Probing questions, contrasting views.",
				"example": "I have to strongly disagree there!"
			},
			"podcast-story": {
				"label": "Storytelling",
				"description": "Delivery built around a story or case study. Emotional engagement, a narrative arc.",
				"example": "Imagine you're standing there…"
			},
			"podcast-fast": {
				"label": "Quick recap",
				"description": "Energetic pace, snap-fire facts, short lines, no filler. Ideal for review.",
				"example": "Let's go! The key idea is…"
			},
			"lecture-basic": {
				"label": "From scratch",
				"description": "Starts from zero, terms are defined on first use, steady pace. Listener is a beginner.",
				"example": "Let's start with the basics…"
			},
			"lecture-exam": {
				"label": "Exam prep",
				"description": "Focus on definitions, formulas and common mistakes. Frequent “remember this”, “important”, “typical error” cues.",
				"example": "Remember this definition…"
			},
			"lecture-review": {
				"label": "Review",
				"description": "Assumes you know the subject. Skims the surface, emphasises connections between topics.",
				"example": "Let's refresh the key connections…"
			},
			"lecture-practice": {
				"label": "Tied to practice",
				"description": "Every theoretical block ends with a real-world application, problem or case.",
				"example": "Now let's apply this in practice…"
			},
			"lecture-source": {
				"label": "Anchored to source",
				"description": "Frequent “as stated in the material” callouts. Quotation-heavy, minimal interpretation.",
				"example": "As stated in the material…"
			},
			"audiobook-artistic": {
				"label": "Literary retelling",
				"description": "Atmosphere, imagery and metaphor. Long, expressive sentences.",
				"example": "Picture a vast tapestry of knowledge…"
			},
			"audiobook-documentary": {
				"label": "Documentary",
				"description": "Neutral tone, facts, chronology. No literary flourishes.",
				"example": "In 1687…"
			},
			"audiobook-bio": {
				"label": "Biographical",
				"description": "Told through the life of the idea's author. Emphasis on how they arrived at the discovery.",
				"example": "The story begins with a person…"
			},
			"audiobook-context": {
				"label": "With asides",
				"description": "Inserts cultural and historical background. “To understand X you need to remember Y.”",
				"example": "To understand this, let's revisit the era…"
			},
			"summary-bullets": {
				"label": "Bullet points only",
				"description": "Bullet-style delivery, no filler. Each idea is a standalone sentence.",
				"example": "Point one…"
			},
			"summary-tldr": {
				"label": "TL;DR + numbers",
				"description": "Key numbers, dates and names. Minimal context.",
				"example": "TL;DR: three numbers, two dates…"
			},
			"summary-weak-spots": {
				"label": "What to revisit",
				"description": "Focuses on the trickiest and weakest spots from the material.",
				"example": "The trickiest spot tends to be…"
			},
			"summary-flashcards": {
				"label": "Inverted flashcards",
				"description": "“Question → pause → answer” structure, made for audio review.",
				"example": "Question. [pause] Answer."
			}
		},
		"customBrief": {
			"toggle": "Custom wishes (optional)",
			"hint": "These notes apply on top of the chosen style.",
			"counter": "{count} / {max}",
			"placeholders": {
				"0": "e.g. “Emphasise the formulas”",
				"1": "e.g. “I'm prepping for a physics exam”",
				"2": "e.g. “Explain it like I'm five”",
				"3": "e.g. “More on practical applications”",
				"4": "e.g. “Use more real-world examples”"
			}
		}
	},
	"persona": {
		"wizard": {
			"label": "Persona style",
			"description": "Choose the host archetype for your podcast",
			"proOnly": "Available on Pro"
		},
		"presets": {
			"podcast": {
				"default": {
					"label": "Curious Host + Mentor Expert",
					"description": "Classic format: host asks, expert explains"
				},
				"skeptical": {
					"label": "Skeptical Interviewer + Patient Teacher",
					"description": "Host probes with sharp follow-ups, expert calmly addresses each challenge"
				},
				"enthusiastic": {
					"label": "Enthusiastic Beginner + Wise Veteran",
					"description": "A fresh-eyed newcomer asking 'naive' questions, paired with a senior practitioner"
				}
			},
			"lecture": {
				"documentary": {
					"label": "Documentary Authority",
					"description": "Calm academic narrator in the BBC tradition"
				},
				"mentor": {
					"label": "Patient Mentor",
					"description": "Warm and methodical — explains as if to a favorite student"
				}
			},
			"audiobook": {
				"literary": {
					"label": "Literary Narrator",
					"description": "Warm, professional audiobook voice"
				},
				"veteran": {
					"label": "Wise Narrator",
					"description": "Senior, measured — narrates from a place of long experience"
				}
			},
			"summary": {
				"briefing": {
					"label": "Briefing Officer",
					"description": "Concise executive briefing"
				},
				"curious": {
					"label": "Curious Investigator",
					"description": "Engaged delivery with real interest — not a dry rundown"
				}
			}
		}
	},
	"intro": {
		"title": "Material you can listen to",
		"body": "A script is written from your sources and read out by voices. It is a finished recording, not a conversation — nothing to answer.",
		"bullets": [
			"Four formats: podcast, lecture, audiobook, digest",
			"A single voice or a dialogue between several",
			"The text highlights in sync with the audio"
		]
	}
}
